import styled, { css } from '@xstyled/styled-components';
import { CarouselVariants } from '../CarouselStore';

export const CarouselItem = styled.div<{
  variant: CarouselVariants;
  index: number;
  current: number;
  total: number;
  disabled?: boolean;
  contentEditableParam?: boolean;
  cssStylesForItem?: any;
}>`
  grid-area: item;
  align-self: center;
  justify-self: center;
  z-index: ${p => p.total + 1 - p.index};

  ${p => {
    if (p.disabled) {
      return css`
        z-index: 1;
      `;
    }
  }}

  ${p => {
    if (p.disabled) {
      return css`
        button {
          display: none !important;
        }
      `;
    }
  }}

  ${p => {
    switch (p.variant) {
      case 'horizontal':
        return css`
          transform: translateX(${(p.index - p.current) * 150}%);
          opacity: ${p.index === p.current ? 1 : 0};
          transition: all ease-in-out 0.7s;

          ${p.contentEditableParam &&
          css`
            height: 80vh;
            overflow-y: auto;

            &::-webkit-scrollbar {
              width: 8px;
              background: transparent;
            }

            &::-webkit-scrollbar-track {
              background: transparent;
            }

            &::-webkit-scrollbar-thumb {
              background-color: grey;
              border-radius: 4px;
            }
          `}
        `;
      case 'vertical':
        return css`
          transform: translateY(${(p.index - p.current) * 150}%);
          opacity: ${p.index === p.current ? 1 : 0};
          transition: all ease-in-out 0.7s;
        `;
      case 'stack':
        return css`
          opacity: ${p.index >= p.current ? 1 : 0};
          transform: translateY(${p.index < p.current ? '-120%' : '0'})
            rotate(${(p.index - p.current) * 3}deg);
          transition: all ease-in-out 0.3s;
        `;
    }
  }}

  ${p => {
    if (p.cssStylesForItem) {
      return css`
        ${p.cssStylesForItem}
      `;
    }
  }}
`;
